// src/pages/AdminPage.js
import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import UserManagement from '../components/UserManagement';
import ParticipantUpload from '../components/ParticipantUpload';

const AdminPage = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Admin Panel
      </Typography>
      
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>User Management</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Create new accounts for staff members and assign them a role. The default password will be the same as the username.
        </Typography>
        <UserManagement />
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Participant Data</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Upload a CSV file to bulk add or update participant records. The system will match records based on the "Email Address" column.
        </Typography>
        <ParticipantUpload />
      </Paper>
    </Container>
  );
};

export default AdminPage;